import { Colors, Icon, Text } from '@amelio/ui-library';

import type { IconProps } from '@amelio/ui-library';

export interface TipIconListItem {
    icon: IconProps['name'];
    description: string;
}

interface TipIconListContentProps {
    items: TipIconListItem[];
}

export const TipIconListContent = ({ items }: TipIconListContentProps) => {
    return (
        <div className={'space-y-6 rounded-xl'}>
            {items.map((item) => (
                <div
                    key={item.description}
                    className={
                        'flex items-start gap-4 rounded-lg border border-slate-200 bg-white !p-4 md:!p-5'
                    }
                >
                    <Icon
                        name={item.icon}
                        size={'md'}
                        color={Colors.SECONDARY}
                        className={'!h-6 !w-6'}
                    />

                    <Text
                        size={'default'}
                        color={Colors.BASE_600}
                        className={'!text-base !text-slate-950'}
                    >
                        {item.description}
                    </Text>
                </div>
            ))}
        </div>
    );
};

export default TipIconListContent;
